export interface CategoriesFilterValues {
  name: string;
  needsTraining: string;
  excluded: string;
}

export const CATEGORIES_FILTER_DEFAULTS: CategoriesFilterValues = {
  name: '',
  needsTraining: '',
  excluded: '',
};

export function hasActiveFilters(filters: CategoriesFilterValues): boolean {
  return filters.name !== '' || filters.needsTraining !== '' || filters.excluded !== '';
}
